import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BeatLoader } from "react-spinners";
import { UsersOtp } from "../../api/Actions/SsoB3/SsoB3";
import setAuthorizationHeaders from "../../api/Config/setAuthorizationHeaders";

const InputOtp = () => {
  const dispatch = useDispatch();
  const [DisableButton, setDisableButton] = useState(false);
  const [ErrorOtp, setErrorOtp] = useState(false);
  const [ErrorMessage, setErrorMessage] = useState(false);
  const [OtpCode, setOtpCode] = useState("");
  const loginData = useSelector((state) => state.UsersLogin.UsersLogin);
  const loginOtp = useSelector((state) => state.UsersLogin.UsersOtp);
  const errorloginOtp = useSelector((state) => state.UsersLogin.errorUsersOtp);
  const domain = localStorage.getItem("domain");

  const HandleEnterButton = (data) => {
    if (data.key === "Enter") {
      HandleContinueButton();
    }
  };

  const HandleContinueButton = () => {
    if (OtpCode.length < 6) {
      setErrorOtp(true);
      setErrorMessage("Please enter valid Otp code.");
    } else {
      setErrorOtp(false);
      setDisableButton(true);

      const data = {
        loginSession: loginData.data.loginSession,
        domain: localStorage.getItem("domain"),
        otpCode:
          loginData.data.type === "SYSTEM_GENERATED"
            ? loginData.data.sanitizedCode + "-" + OtpCode
            : "" + OtpCode,
        otpId: loginData.data.otpId,
        recoveryKey: "null",
        type:
          loginData.data.type === "SYSTEM_GENERATED"
            ? "system_generated"
            : "totp",
      };
      dispatch(UsersOtp(data));
    }
  };

  const HideEmail = (data) => {
    let str = data;
    str = str.split("");
    let email = [];
    let len = str.indexOf("@");
    const ViewEmail = Math.floor(len / 2);
    str.forEach((item, pos) => {
      pos >= ViewEmail && pos <= len - 1
        ? email.push("*")
        : email.push(str[pos]);
    });
    const hashEmail = email.join("");
    return hashEmail;
  };

  useEffect(() => {
    if (loginOtp.success) {
      dispatch({
        type: "set",
        loginProcess: "org",
      });
      if (window.location.origin.includes("localhost"))
        setAuthorizationHeaders(loginOtp.data.sessionToken, domain);
      localStorage.setItem("identityUuid", loginOtp.data.identityUuid);
      localStorage.setItem("sessionToken", loginOtp.data.sessionToken);
      // console.log(loginOtp, "hasil dari verify otp");
    }
    if (ErrorOtp) {
      setErrorOtp(true);
      setErrorMessage("Please enter valid Otp code.");
      setDisableButton(false);
    }
  }, [loginOtp]);

  useEffect(() => {
    if (errorloginOtp) {
      setErrorOtp(true);
      setErrorMessage("Please enter valid Otp code.");
      setDisableButton(false);
    }
  }, [errorloginOtp]);

  return (
    <>
      <div className="my-auto">
        <div className="flex flex-col w-4/5 lg:w-4/6 mx-auto">
          <div className="w-full">
            <p className="my-10 poppins-500 text-white tracking-widest">
              Enter the OTP code we just sent to{" "}
              {HideEmail(loginData.data.email)} for verification :
            </p>
          </div>
          <div className="flex flex-row items-center my-4">
            {loginData.data.type === "TOTP" ? (
              ""
            ) : (
              <div className="flex w-1/4 mx-auto">
                <p className="poppins-800 text-white tracking-lg">
                  {loginData.data.sanitizedCode} -
                </p>
              </div>
            )}
            <div className="w-full">
              <input
                onKeyDown={(e) => HandleEnterButton(e)}
                onChange={(e) => setOtpCode(e.target.value)}
                className="rounded-lg h-12 w-full text-center font-bold tracking-xl"
              />
            </div>
          </div>
          <div className="flex flex-row items-center justify-between">
            {/* <button
              onClick={(e) => HandleBackButton()}
              className="my-3 text-main-blue text-sm rad w-2/5 h-14 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
            >
              BACK
            </button> */}
            <button
              onClick={(e) => HandleContinueButton()}
              disabled={DisableButton}
              className="my-3 mx-auto text-main-blue text-sm rad w-2/5 h-14 bg-white rounded-md poppins-800 text-blue-b3 tracking-widest hover:bg-slate-200"
            >
              {DisableButton ? (
                <BeatLoader className="my-auto" color="#075985" size={8} />
              ) : (
                "CONTINUE"
              )}
            </button>
          </div>
        </div>
        {ErrorOtp ? (
          <p className="text-red-500 text-center">{ErrorMessage}</p>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default InputOtp;
